import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
			staleTime: 5 * 60 * 1000, // 5 minutes
		},
	},
});


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<QueryClientProvider client={queryClient}>
		<BrowserRouter>
			<RecoilRoot>
				<ErrorBoundary>
					<App />
				</ErrorBoundary>
			</RecoilRoot>
		</BrowserRouter>
	</QueryClientProvider>
);

